module.exports = __webpack_public_path__ + "img/q4.b21bc3ca.png";